import React from 'react';

function Alert({ tone = 'success', children, role = 'status' }) {
	const toneClass = tone === 'danger' ? 'alert-danger' : tone === 'warning' ? 'alert-warning' : 'alert-success';
	return (
		<div className={`alert ${toneClass}`} role={role}>
			{children}
		</div>
	);
}

export default Alert;
